import React from 'react';
import type { ButtonProps } from '@quero-delivery/quero-components-web';
import { ButtonMain } from '@quero-delivery/quero-components-web';

import styles from './styles.module.scss';

type Props = ButtonProps;

function PurpleButton({ className, ...rest }: Props) {
  return (
    <ButtonMain
      className={`${className || ''} ${styles.purpleButton}`}
      {...rest}
    />
  );
}

export default PurpleButton;
